import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: tokens.fontSizeBase300,
  },
  headerRow: {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: tokens.colorNeutralStroke2,
  },
  headerCell: {
    textAlign: 'left',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    color: tokens.colorNeutralForeground3,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase200,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    whiteSpace: 'nowrap',
  },
  row: {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: tokens.colorNeutralStroke3,
    ':hover': { backgroundColor: tokens.colorNeutralBackground2Hover },
  },
  rowExpanded: {
    backgroundColor: tokens.colorNeutralBackground2,
  },
  cell: {
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    verticalAlign: 'top',
  },
  indexCell: {
    color: tokens.colorNeutralForeground3,
    fontVariantNumeric: 'tabular-nums',
    width: '36px',
  },
  chevronCell: {
    width: '32px',
    padding: `${tokens.spacingVerticalXS} 0 ${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
  },
  expansionRow: {
    backgroundColor: tokens.colorNeutralBackground2,
  },
  expansionCell: {
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL}`,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: tokens.colorNeutralStroke3,
  },
});
